<template>
  <!-- <Modal
    titleText="ชำระเงิน QR CODE"
    titleClass="fs24 bold7 darkBlue mt-4"
    :titleStyle="{ width: '100%', 'text-align': 'center' }"
    :show="openModalPayment"
    :buttonClose="true"
    id="openModalPayment"
    @close="openModalPayment = false"
    style="overflow-y: scroll; height: auto"
  > -->
    <div>
      <div class="modal-title fs24 darkBlue bold7 mt-4" style="text-align:center;margin-bottom:20px">ชำระเงิน QR CODE</div>
      <ValidationObserver ref="form">
        <div
          style="
            flex-direction: column;
            padding-left: 50px;
            padding-right: 50px;
            padding-bottom: 50px;
          "
        >
          <Typography
            class="flex-all-center"
            style="align-items: center"
            text="กรุณาทำการชำระเงินภายใน"
          />
          <Typography
            class="flex-all-center"
            style="align-items: center"
            h2
            medium
            :text="dataPayment.due_date"
          />

          <div style="display: flex; align-items: end; justify-content: center">
            <img
              :src="dataPayment.qrcodeUrl"
              width="200"
              height="200"
              alt="QR Code"
            />
            <button
              @click="downloadQRCode"
            >
              <img
                :src="iconDownload"
                style="margin-bottom: 15px"
                width="29"
                height="29"
                alt="iconDownload"
              />
            </button>
            
          </div>
          <div
              style="display: flex; align-items: end; justify-content: center"
            >
              <Btn
                style="width: 80%"
                white
                text="Download Bill Payment"
                radius="25"
                width="100%"
                height="20"
                fontSize="12"
                bold
                @click="
                  () => {
                    postDownloadSlip(dataPayment.transaction_id);
                  }
                "
              />
            </div>

          <div style="display: flex; flex-direction: row">
            <Typography bold text="รหัสอ้างอิง 1:" />
            <Typography
              semibold
              style="margin-left: 5px"
              :text="dataPayment.refferalCode1"
            />
          </div>

          <div style="display: flex; flex-direction: row">
            <Typography bold text="รหัสอ้างอิง 2:" />
            <Typography
              semibold
              style="margin-left: 5px"
              :text="dataPayment.refferalCode2"
            />
          </div>

          <div
            class="bg-lightBlue01"
            style="
              display: flex;
              align-items: center;
              justify-content: right;
              padding-right: 30px;
              height: 50px;
              border-radius: 10px;
              margin-top: 17px;
            "
          >
            <Typography h7 text="ยอดที่ต้องชำระ" />
            <Typography
              h8
              style="margin-left: 7px"
              fontColor="errors"
              text="฿"
            />
            <Typography
              style="margin-left: 7px"
              h2
              fontColor="errors"
              :text="bath"
            />
          </div>

          <div>
            <Typography
              semibold
              style="margin-top: 25px; margin-left: 10px"
              text="แนบสลิปการชำระเงิน"
            />
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="แนบสลิปการชำระเงิน"
              v-slot="{ errors }"
            >
              <UploadDocument
                :errors="errors"
                @input="uploadImg"
                :typeFile="',image/*'"
                width="100%"
                v-model="dataPayment.slipfile"
                :showListFile="true"
                removeDisplay
              >
              </UploadDocument>
              <div v-if="errors[0]" class="error-warning pr-2">
                <div class="pr-2">กรุณาแนบสลิปการชำระเงิน</div>
              </div>
            </ValidationProvider>
          </div>
          <!-- <div>
            <v-row style="margin-top: 10px">
              <v-col cols="6">
                <div class="mt-2 mb-5">
                  <Typography
                    style="margin-left: 10px"
                    semibold
                    text="วันที่ชำระเงิน"
                  />
                  <ValidationProvider
                    :rules="{
                      required: true,
                    }"
                    name="วันที่ชำระเงิน"
                    v-slot="{ errors }"
                  >
                    <date-picker
                      :append-to-body="false"
                      :clearable="false"
                      name="Date"
                      v-model="dataPayment.paid_date"
                      valueType="format"
                      format="DD/MM/YYYY"
                      placeholder="เลือกวันที่"
                      confirm
                      class="datepickerPaymentDate"
                    >
                      <template v-slot:footer="{ emit }">
                        <div style="text-align: left">
                          <button
                            class="mx-btn mx-btn-text"
                            @click="emit(new Date())"
                          >
                            Today
                          </button>
                        </div>
                      </template>
                    </date-picker>
                    <div v-if="errors[0]" class="error-warning pr-2">
                      <div class="pr-2">กรุณาเลือกวันที่ชำระเงิน</div>
                    </div>
                  </ValidationProvider>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="mt-2 mb-5">
                  <Typography
                    semibold
                    style="margin-top: 10px; margin-left: 10px"
                    text="เวลาชำระเงิน"
                  />
                  <ValidationProvider
                    :rules="{
                      required: true,
                    }"
                    name="เวลาชำระเงิน"
                    v-slot="{ errors }"
                  >
                    <date-picker
                      :append-to-body="false"
                      :clearable="false"
                      name="Time"
                      v-model="dataPayment.paid_time"
                      type="time"
                      format="HH:mm"
                      value-type="format"
                      placeholder="เลือกเวลา"
                      confirm
                      class="datepickerPaymentTime"
                    >
                    </date-picker>
                    <div v-if="errors[0]" class="error-warning pr-2">
                      <div class="pr-2">กรุณาเลือกเวลาชำระเงิน</div>
                    </div>
                  </ValidationProvider>
                </div>
              </v-col>
            </v-row>
          </div> -->

          <!-- <div>
            <Typography
              semibold
              style="margin-left: 10px"
              text="ธนาคารที่ทำการชำระเงิน"
            />
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="ธนาคารที่ทำการชำระเงิน"
              v-slot="{ errors }"
            >
              <v-select
                placeholder="เลือกธนาคารที่ชำระเงิน"
                class="inputPaymentSelectField mb-1"
                :items="bank"
                item-text="label"
                item-value="value"
                v-model="dataPayment.bankname"
                hide-details
                dense
                outlined
                append-icon="mdi-chevron-down"
                style="margin-top: 5px"
              />
              <div v-if="errors[0]" class="error-warning pr-2">
                <div class="pr-2">กรุณาเลือกธนาคารที่ทำการชำระเงิน</div>
              </div>
            </ValidationProvider>
          </div> -->

          <!-- <div>
            <Typography
              semibold
              style="margin-left: 10px; margin-top: 10px"
              text="ยอดเงินที่ชำระ"
            />
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="ยอดเงินที่ชำระ"
              v-slot="{ errors }"
            >
              <custom-input
                type="text"
                class="inputPaymentField"
                placeholder="20.00"
                v-model="dataPayment.amount"
                dense
                id="amount"
                name="amount"
                outlined
                style="margin-top: 5px; border-radius: 8px"
              />
              <div v-if="errors[0]" class="error-warning pr-2">
                <div class="pr-2">
                  {{ errors[0] }}
                </div>
              </div>
            </ValidationProvider>
          </div> -->

          <div
            class="flex-all-center mt-10"
            style="justify-content: space-evenly"
          >
            <Btn
              style="width: 48%"
              white
              text="ยกเลิก"
              radius="25"
              width="100%"
              height="40"
              fontSize="16"
              bold
              @click="showModalPayment"
            />

            <Btn
              style="width: 48%"
              blue
              text="บันทึก"
              radius="25"
              width="100%"
              height="40"
              fontSize="16"
              bold
              @click="postUpdateSlip"
            />
          </div>
        </div>
      </ValidationObserver>
    </div>
  <!-- </Modal> -->
</template>

<script>
// import Modal from "@/components/modal/Modal";
import api from "@/api";
import QRCode from "qrcode";
import UploadDocument from "@/components/UploadDocument";
import CustomInput from "@/components/CustomInput"
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";

export default {
  components: {
    DatePicker,
    // Modal,
    UploadDocument,
    CustomInput,
  },

  props: {
    openModalPayment: {
      type: Boolean,
      defalut: true,
    },
  },

  data() {
    return {
      iconDownload: require("@/assets/image/iconDownload.png"),
      iconErrorPayment: require("@/assets/image/errorPayment.png"),
      bath: "",
      dataPayment: {
        refferalCode1: "",
        refferalCode2: "",
        qrcodeText: "",
        qrcodeUrl: "",
        slipfile: "",
        paid_date: "",
        paid_time: "",
        bankname: "",
        amount: "",
        due_date: "",
        transaction_id: "",
      },

      bank: [
        { label: "ธนาคารกรุงไทย จำกัด (มหาชน) ", value: "KTB" },
        { label: "ธนาคารกสิกรไทย จำกัด (มหาชน)", value: "KBANK" },
        { label: "ธนาคารเกียรตินาคิน (มหาชน)", value: "KK" },
        { label: "ธนาคารทิสโก้ จำกัด (มหาชน) ", value: "TISCO" },
        { label: "ธนาคารทหารไทยธนชาต จำกัด (มหาชน)", value: "TTB" },

        { label: "ธนาคารกรุงเทพ จำกัด (มหาชน)", value: "BBL" },
        { label: "ธนาคารไทยพาณิชย์ จำกัด (มหาชน) ", value: "SCB" },
        { label: "ธนาคารออมสิน จำกัด (มหาชน)", value: "GSB" },
        { label: "ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)", value: "BAY" },
        { label: "ธนาคารซิตี้แบงก์ ", value: "CITY" },

        { label: "ธนาคารซีไอเอ็มบีไทย จำกัด", value: "CIMBT" },
        { label: "ธนาคารยูโอบี จำกัด (มหาชน) ", value: "UOB" },
        { label: "ธนาคารมิซูโฮจำกัด จำกัด (มหาชน)", value: "Mizuho" },
        { label: "ธนาคารไอซีบีซี", value: "ICBC" },
      ],
      pollingInterval: null,
      hasShownPopup: false,
    };
  },

  computed: {
    memberid() {
      const memberid = this.$store.state.memberid
      let index = -1
      for (let i = 0; i < memberid.length; i++) {
        if (memberid[i] !== '0') {
          index = i
          break;
        }
      }
      return memberid.slice(index)
    }
  },

  mounted() {
    this.getDataPayment();
    this.checkPaymentStatus();
  },
  methods: {
    async startPolling() {
      this.hasShownPopup = false;
      this.pollingInterval = setInterval(async () => {
        try {
          await this.checkPaymentStatus();
        } catch (error) {
          console.error('Error checking status:', error);
        }
      }, 5000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    downloadQRCode() {
      const url = this.dataPayment.qrcodeUrl;
      const link = document.createElement('a');
      link.href = url;

      link.download = `depaQRcode-${this.dataPayment.refferalCode1}.png`; 
      link.click();
    },
    
    async checkPaymentStatus() {
      let checkdata = {
        ref1: this.dataPayment.refferalCode1,
        ref2: this.dataPayment.refferalCode2,
      };
      const data = await api.getPaymentStatus(checkdata);
      if (data.responsecode == 200 && !this.hasShownPopup){
        this.hasShownPopup = true;
        this.stopPolling(); 
        this.$swal.fire({
            title: "ชำระเงินสำเร็จ",
            icon: "success",
            confirmButtonText: 'ตกลง'
          })
          .then(() => {
            this.sendPaymenttOdoo(data.data[0].name,data.data[0].institute_name,data.data[0].id_card, data.data[0].amount,data.data[0].memberid);
          });
      }
      else{
        this.startPolling();
      }
      
    },
    async sendPaymenttOdoo(name,institute_name,id_card,price,memberid) {
      if (!name){
        name = institute_name;
      }
      let data =  {
        name: name,
        tax: id_card,
        price: price,
        memberid: memberid
      }
      
      const res = await api.sendodoo(data);
      if (res.responsecode == 201){
        return res.message;
      }
    },

    async getDataPayment() {
      const memberid = this.memberid
      const sessiontoken = this.$store.state.sessiontoken
      const { data } = await api.getPayment(memberid, sessiontoken);
      this.dataPayment = {
        refferalCode1: data.data[0].qrcode_data.ref1,
        refferalCode2: data.data[0].qrcode_data.ref2,
        qrcodeText: data.data[0].qrcode_text,
        due_date: moment(data.data[0].duedate).format("DD/MM/YYYY"),
        transaction_id: data.data[0].transaction_id,
      };
      // console.log("dataPayment", this.dataPayment);
      this.bath = data.data[0].amount;
      this.generateQRCode();
    },

    async postUpdateSlip() {
      if (await this.$refs.form.validate()) {
        const memberid = this.memberid
        const sessiontoken = this.$store.state.sessiontoken
        const sendData = {
          slipfile: this.dataPayment.slipfile[0],
          //paid_date: moment(this.dataPayment.paid_date, "DD/MM/YYYY").format(
          //  "YYYY-MM-DD"
          //),
          //paid_time: this.dataPayment.paid_time,
          //bankname: this.dataPayment.bankname,
          transaction_id: this.dataPayment.transaction_id,
        };
        const { data } = await api.updateSlip(sendData, memberid, sessiontoken);
        if (data.data.responsecode == 200) {
          this.openModalPayment = false;
          this.$swal
            .fire({
              type: "success",
              title: "ชำระเงินสำเร็จ",
              html: `
              แอดมินกำลังดำเนินการตรวจสอบรายการของท่าน
              <br>
              <span style="color: orange; margin-top: 10px">
                <span style="display: inline-block; width: 7px; height: 7px; background-color: orange; margin-right: 5px; border-radius: 10px; margin-bottom: 1px"></span>
                รอการตรวจสอบ
              </span>
            `,
              icon: "success",
              confirmButtonText:
                '<span style="padding: 15px" >ตกลง</span>',
            })
            .then((result) => {
              if (result.isConfirmed) {
                window.liff.closeWindow();
              }
            });
        } else {
          this.openModalPayment = false;
          this.$swal
            .fire({
              type: "error",
              title: "ชำระเงินไม่สำเร็จ",
              html: `
              กรุณาตรวจสอบข้อมูลอีกครั้ง
            `,
              icon: "error",
              confirmButtonText: "ลองอีกครั้ง",
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.openModalPayment = true;
              }
            });
        }
      }
    },

    async postDownloadSlip() {
      const memberid = this.memberid
      const sessiontoken = this.$store.state.sessiontoken
      const transactionId = this.dataPayment.transaction_id
      const { data } = await api.downloadSlip(memberid, sessiontoken, transactionId);
      const href = URL.createObjectURL(data);
      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", "payment.pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    },

    goTo(path) {
      this.$router.push(`/${path}`);
    },

    showModalPayment() {
      this.openModalPayment = !this.openModalPayment;
    },

    async generateQRCode() {
      await QRCode.toDataURL(this.dataPayment.qrcodeText, (err, url) => {
        if (err) {
          console.error(err);
          return;
        }
        this.dataPayment.qrcodeUrl = url;
      });
    },

    async uploadImg(data) {
      // console.log("uploadImg :", data);
      let uploaddata = {};
      // console.log("dataPayment", this.dataPayment)
    },
  },
};
</script>

<style lang="scss" scoped>
.swal2-confirm {
  background-color: green;
  color: white;
  border: none;
}
</style>
